<!-- 项目信息 -->
<template>
  <div>
    <k-form-build :value="jsonData" ref="KFB" />
  </div>
</template>
<script>
export default {
  name: 'ProjectSponsor',
  data() {
    return {
      jsonData: {
        list: [
          {
            type: 'input',
            icon: 'icon-edit',
            options: {
              width: '100%',
              minRows: 4,
              maxRows: 6,
              maxLength: null,
              defaultValue: '',
              clearable: false,
              hidden: false,
              placeholder: '项目编号',
            },
            model: '2f3f0581-2a41-2b7c-e4f7-e6d148b49d94',
            key: '2f3f0581-2a41-2b7c-e4f7-e6d148b49d94',
            rules: [
              {
                required: false,
                message: '必填项',
              },
            ],
          },
        ],
        config: {
          layout: 'vertical',
          labelCol: {
            span: 4,
          },
          wrapperCol: {
            span: 18,
          },
          hideRequiredMark: false,
          customStyle: '',
        },
      },
    };
  },
  methods: {},
  mounted() {},
};
</script>
